import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/codebuild/output/src1898816064/src/treeunfe-website-nextjs/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1898816064/src/treeunfe-website-nextjs/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalBreadcrumb"] */ "/codebuild/output/src1898816064/src/treeunfe-website-nextjs/src/components/organisms/global-breadcrumb/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1898816064/src/treeunfe-website-nextjs/src/components/pages/landing-page/blog/magicui/particles.tsx");
